import { countries, citiesByCountry, type Country } from "@/data/photographers";

export { countries, citiesByCountry };
export type { Country };

export type VisagistTheme =
  | "day-makeup"
  | "evening-makeup"
  | "bridal"
  | "editorial"
  | "open";

export const visagistThemes: { id: VisagistTheme; label: string; description: string }[] = [
  { id: "day-makeup", label: "Tages Make Up", description: "Natürliches Tages-Make-Up, frische, alltagstaugliche Looks." },
  { id: "evening-makeup", label: "Abend Make Up", description: "Glamouröse Abend-Looks, Galas, Events, Foto-Shootings." },
  { id: "bridal", label: "Brautstyling", description: "Brautstyling, Make-Up und Hair für den schönsten Tag." },
  { id: "editorial", label: "Editorial / Fashion", description: "Editorial-, Fashion- und Kampagnen-Make-Up." },
  { id: "open", label: "Open", description: "Freie Arbeiten, alles zwischen Tages-Look und Editorial." },
];

export type Visagist = {
  id: string; // slug
  name: string;
  region: string;
  themes: VisagistTheme[];
  priceFrom: number;
  bio: string;
  email: string;
  portrait: string;
  gallery: string[];
  galleryThemes?: VisagistTheme[];
  country?: string | null;
  city?: string | null;
  websiteUrl?: string | null;
  instagramHandle?: string | null;
  portraitPosition?: string | null;
  portraitZoom?: number | null;
  shootingSettings?: string[];
  languages?: string[];
  foundingMember?: boolean;
  tfp?: boolean;
  priceOnRequest?: boolean;
};

export const visagistPriceBuckets = [
  { id: "lt200", label: "bis 200 €", min: 0, max: 199 },
  { id: "200-500", label: "200, 500 €", min: 200, max: 500 },
  { id: "500-1000", label: "500, 1.000 €", min: 500, max: 1000 },
  { id: "gt1000", label: "ab 1.000 €", min: 1000, max: Number.MAX_SAFE_INTEGER },
] as const;
export type VisagistPriceBucketId = (typeof visagistPriceBuckets)[number]["id"];